
<!-- BENEFICIOS -->
<mat-toolbar class="titulopartes">Renda</mat-toolbar>

<div fxLayout="column" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <div fxLayout="row" fxFlexFill>
        <mat-form-field fxFlex="20%" fxFlexOffset="20px">
            <input currencyMask matInput maxlength="10" name="valorRendaCtps" placeholder="Valor Renda:"
                   [(ngModel)]="pessoaFisica.valorRendaCtps" 
                   [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
            <span matPrefix>R$&nbsp;</span>
        </mat-form-field>
        <mat-form-field fxFlex="20%" fxFlexOffset="20px">
            <input matInput maxlength="200" name="origemRendaFamiliar" placeholder="Oridem da Renda:"
                   [(ngModel)]="pessoaFisica.origemRendaFamiliar">
        </mat-form-field>
    </div>

    <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoBeneficio">
        <div *ngFor="let beneficio of beneficiosSociaisPessoaFisica; let index = index">
            <beneficio-social-pessoa-fisica-aluno 
                                       [beneficio]="beneficio" 
                                       [index]="index"
                                       [beneficiosSociaisPessoaFisica]="beneficiosSociaisPessoaFisica"   
                                       [perfilAcesso]="perfilAcesso"
                                       [beneficiosSociais]="beneficiosSociais" 
                                       >
            </beneficio-social-pessoa-fisica-aluno>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" fxFlexFill>
            <mat-form-field fxFlexOffset="20px" fxFlex="20%">
                <input name="valor_{{pinValor}}"
                       [value]="calcularValorTotalRenda() | currency:'BRL':'symbol':'1.2-2'" 
                       placeholder="Valor Total da Renda:" 
                       matInput 
                       maxlength="13"
                       readonly />
            </mat-form-field>
        </div>        
        <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px" style="padding-top: 10px; padding-left: 20px; padding-bottom: 10px;">
            <div>
                <button type="button" matTooltip="Novo" mat-mini-fab color="primary" (click)="addBeneficio()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>                
    </div>

</div>